import Router from 'next/router';
import getConfig from 'next/config';
import { useEffect } from 'react';
import { markHydrated } from '@/common/hooks/useProgressiveMount';
import { startNextDataPrefetch } from '@/common/services/navigation/nextDataPrefetch';
import { startRouteFade } from '@/common/services/navigation/routeFade';
import { startRouteTransitionRum } from '@/common/services/rum/routeTransition';

/**
 * Client-side navigation performance: intent prefetch of `/_next/data`, transition RUM,
 * the search ↔ profile fade, and the hydration mark that enables progressive list mounting.
 * Renders nothing. See docs/performance.md.
 */
export default function NavigationPerf() {
  useEffect(() => {
    // Runs after the hydration commit: from now on long lists mount progressively.
    markHydrated();
    const stopPrefetch = startNextDataPrefetch(Router);
    const stopFade = startRouteFade(Router);
    const { publicRuntimeConfig } = getConfig() ?? {};
    // Same gate as reportWebVitals in _app: no RUM from dev/staging.
    const stopRum = publicRuntimeConfig?.IS_PRODUCTION ? startRouteTransitionRum(Router) : () => undefined;
    return () => {
      stopPrefetch();
      stopFade();
      stopRum();
    };
  }, []);

  return null;
}
